import { render, staticRenderFns } from "./Piles.vue?vue&type=template&id=509add24&scoped=true"
import script from "./Piles.vue?vue&type=script&lang=js"
export * from "./Piles.vue?vue&type=script&lang=js"
import style0 from "./Piles.vue?vue&type=style&index=0&id=509add24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509add24",
  null
  
)

export default component.exports